<button class="mat-flat-button save-view-btn" (click)="togglePanel()"><mat-icon>more_vert</mat-icon></button>
<mat-card [ngClass]="{open: panelOpen}">
    <mat-card-content fxLayout="column">
        <button class="mat-flat-button" (click)="openViewSettings(false)"><mat-icon>assignment_return</mat-icon> Create View</button>
        <button class="mat-flat-button" *ngIf="vs.currentView" (click)="openViewSettings(true)"><mat-icon>save</mat-icon> Save Current View</button>
        <button class="mat-flat-button" *ngIf="!vs.currentView" (click)="fs.reset()"><mat-icon>delete</mat-icon> Back to Default</button>
        <button class="mat-flat-button" *ngIf="vs.currentView" (click)="vs.trash()"><mat-icon>delete</mat-icon> Trash</button>
    </mat-card-content>
</mat-card>